import { Gradient } from '@/../marketing/helpers/gradient';

export enum BlogCategory {
    NEWS = 'News',
    UPDATES = 'Updates',
    TUTORIAL = 'Tutorial',
}

const blogCategories: {
    [key in BlogCategory]: {
        key: BlogCategory;
        label: string;
        gradient: Gradient;
    };
} = {
    [BlogCategory.NEWS]: {
        key: BlogCategory.NEWS,
        label: 'News',
        gradient: 'red',
    },
    [BlogCategory.UPDATES]: {
        key: BlogCategory.UPDATES,
        label: 'Updates',
        gradient: 'green',
    },
    [BlogCategory.TUTORIAL]: {
        key: BlogCategory.TUTORIAL,
        label: 'Tutorial',
        gradient: 'blue',
    },
};

export { blogCategories };
